import { MutationTree } from 'vuex';
import { DetectionRulesRecordState, LogFile, DetectionRuleSearchInfo, DetectionRuleLogEdit } from './types';
import * as types from './mutation-types';
import { ErrorDetail } from '../../types';

// エラーをクリアする
const resetErrors = (state: DetectionRulesRecordState): void => {
    const searchState = state.search;
    searchState.error = false;
    searchState.errorTitle = undefined;
    searchState.errorDetails = undefined;

    const showState = state.show;
    showState.error = false;
    showState.errorCode = undefined;
    showState.errorMsg = undefined;

    const logFileState = state.logFile;
    logFileState.error = false;
    logFileState.errorTitle = undefined;
    logFileState.errorDetails = undefined;

    const csvState = state.csv;
    csvState.error = false;
    csvState.errorTitle = undefined;
    csvState.errorDetails = undefined;
};

export const mutations: MutationTree<DetectionRulesRecordState> = {
    // 検知記録の一覧取得系
    [types.SEARCH_START](state) {
        resetErrors(state);
        const searchState = state.search;
        searchState.isProcessing = true;
        searchState.isFetchSuccess = false;
    },

    [types.SEARCH_SUCCESS](state, payload: { count: number; detection_rules_records: Array<DetectionRuleSearchInfo> }) {
        state.detectionRulesRecordCount = payload.count;
        state.detectionRulesRecords = payload.detection_rules_records;

        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = true;
    },

    [types.SEARCH_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const searchState = state.search;
        searchState.errorTitle = payload.errorTitle;
        searchState.errorDetails = payload.errorDetails;
        searchState.error = true;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;
    },

    // 検知記録の詳細取得系
    [types.SHOW_START](state) {
        resetErrors(state);
        const showState = state.show;
        showState.isProcessing = true;
        showState.isFetchSuccess = false;
    },

    [types.SHOW_SUCCESS](state, payload: DetectionRuleLogEdit) {
        state.detectionRulesRecordDetails = payload;

        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = true;
    },

    [types.SHOW_FAILURE](state, payload: { code: string; message: string }) {
        const showState = state.show;
        showState.errorCode = payload.code;
        showState.errorMsg = payload.message;
        showState.error = true;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;
    },

    // 検知情報の取得系
    [types.LOG_FILE_START](state) {
        const logFileState = state.logFile;
        logFileState.error = false;
        logFileState.errorTitle = undefined;
        logFileState.errorDetails = undefined;
        logFileState.isProcessing = true;
        logFileState.isFetchSuccess = false;
    },

    [types.LOG_FILE_SUCCESS](state, payload: { log_file_details: LogFile }) {
        state.logFileDetails = payload.log_file_details;

        const logFileState = state.logFile;
        logFileState.isProcessing = false;
        logFileState.isFetchSuccess = true;
    },

    [types.LOG_FILE_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const logFileState = state.logFile;
        logFileState.errorDetails = payload.errorDetails;
        logFileState.errorTitle = payload.errorTitle;
        logFileState.error = true;
        logFileState.isProcessing = false;
        logFileState.isFetchSuccess = false;
    },

    // CSV出力系
    [types.CSV_OUTPUT_START](state) {
        resetErrors(state);
        const csvState = state.csv;
        csvState.isProcessing = true;
    },

    [types.CSV_OUTPUT_SUCCESS](state) {
        const csvState = state.csv;
        csvState.isProcessing = false;
    },

    [types.CSV_OUTPUT_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const csvState = state.csv;
        csvState.errorTitle = payload.errorTitle;
        csvState.errorDetails = payload.errorDetails;
        csvState.error = true;
        csvState.isProcessing = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;

        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;

        const logFileState = state.logFile;
        logFileState.isProcessing = false;
        logFileState.isFetchSuccess = false;

        const csvState = state.csv;
        csvState.isProcessing = false;
    },

    [types.CLEAR_ALL](state) {
        resetErrors(state);
        state.detectionRulesRecords = undefined;
        state.detectionRulesRecordCount = 0;
        state.detectionRulesRecordDetails = undefined;
        state.logFileDetails = undefined;
    },
};
